import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=0c231c2a&scoped=true&"
import script from "./OrderDetails.vue?vue&type=script&lang=js&"
export * from "./OrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=0c231c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c231c2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c231c2a')) {
      api.createRecord('0c231c2a', component.options)
    } else {
      api.reload('0c231c2a', component.options)
    }
    module.hot.accept("./OrderDetails.vue?vue&type=template&id=0c231c2a&scoped=true&", function () {
      api.rerender('0c231c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/OrderDetails.vue"
export default component.exports